function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M20.085384,3.9187939 C19.8353543,3.67002651 19.5019814,3.58710404 19.1686084,3.75294898 L3.33339273,11.2159708 C3.00001977,11.3818158 2.83333329,11.7135057 2.83333329,12.0451955 C2.83333329,12.3768854 3.08336301,12.7085753 3.50007921,12.7914977 L9.667479,14.3670245 L11.2510006,20.503287 C11.3343438,20.8349769 11.6677167,21.0837442 12.0010898,21.1666666 C12.0010898,21.1666666 12.084433,21.1666666 12.084433,21.1666666 C12.4178059,21.1666666 12.6678357,21.0008218 12.8345221,20.669132 L20.3354138,4.91386349 C20.418757,4.49925116 20.3354138,4.1675613 20.085384,3.9187939 Z M12.2511194,17.7668456 L11.1676573,13.4548774 C11.0843141,13.1231876 10.8342843,12.9573427 10.5842547,12.8744202 L6.1670629,11.7135057 L17.7517733,6.24062294 L12.2511194,17.7668456 Z",
  id: "path-1"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "UI-Web",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "01-Trip-Planer-Suggest-routes-Options-2",
  transform: "translate(-1379.000000, -868.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-14-Copy",
  transform: "translate(1372.000000, 861.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icons/feather/navigation",
  transform: "translate(7.000000, 7.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "navigation",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "\\uD83C\\uDFA8-color",
  mask: "url(#mask-2)",
  fill: "#546E7A"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Select-color",
  x: 0,
  y: 0,
  width: 24.24,
  height: 24.24
}))))));
function SvgRecenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1365CE37-5120-476A-86B8-1F4ABE4F2C06") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecenter);
export default __webpack_public_path__ + "static/media/recenter.b6334448e89825b607a8815709083c23.svg";
export { ForwardRef as ReactComponent };